import { Component, Inject } from '@angular/core';
import { HsgModalDefault, HsgModalRef, HsgModalDefaultData, HSG_MODAL_DATA } from '@hhsg/hsg-asc';

@Component({
    selector: 'smt-staffing-grid-modal',
    templateUrl: './staffing-grid-modal.component.html',
    styleUrls: ['./staffing-grid-modal.component.scss']
})

export class StaffingGridModalComponent extends HsgModalDefault {
    constructor(
		public modalRef: HsgModalRef<HsgModalDefault>,
		@Inject(HSG_MODAL_DATA) public data: any) { 
        super(modalRef, data);
    }

    close() {
        this.modalRef.close();
    }
}
